import { SOIN_IMAGE } from "@/lib/soins";

export const soinNomCourt = (titre) => titre.split(/\s+[—–-]\s+/)[0].trim();
export const soinDateCourte = (iso) => { const d = new Date(iso); return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`; };

// Visuel officiel des soins collectifs : uniquement le nom du soin et la date, même famille visuelle pour tous.
export const SoinVisuel = ({ soin, className = "", compact = false, testid }) => (
  <div className={`relative overflow-hidden bg-earth ${className}`} data-testid={testid || `soin-visuel-${soin.id.slice(0, 8)}`}>
    <img src={soin.image || SOIN_IMAGE} alt="" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-t from-earth/85 via-earth/25 to-earth/10" />
    <div className="absolute inset-x-0 bottom-0 p-5 sm:p-7 lg:p-9 text-sand">
      <p className={`font-serif font-medium leading-[1.02] tracking-[-0.01em] drop-shadow-[0_2px_12px_rgba(0,0,0,0.45)] ${compact ? "text-2xl sm:text-3xl" : "text-3xl sm:text-4xl lg:text-5xl"}`} data-testid="soin-visuel-nom">{soinNomCourt(soin.titre)}</p>
      <p className={`mt-2 font-sans font-light tracking-[0.22em] text-terra ${compact ? "text-xs" : "text-sm lg:text-base"}`} data-testid="soin-visuel-date">{soinDateCourte(soin.date)}</p>
    </div>
  </div>
);
